import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WarningIcon = function WarningIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WarningIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.725 2.41c.949-1.88 3.601-1.88 4.55 0l4.448 8.822c.829 1.645-.28 3.768-2.275 3.768H3.552c-1.995 0-3.104-2.123-2.275-3.768zm3.181.69a1.007 1.007 0 0 0-1.812 0L2.646 11.92c-.356.705.138 1.548.906 1.548h8.896c.768 0 1.261-.843.906-1.548zM8 4.937c.484 0 .875.392.875.875V8a.875.875 0 0 1-1.75 0V5.812c0-.483.391-.875.875-.875m0 7.438a1.094 1.094 0 1 0 0-2.188 1.094 1.094 0 0 0 0 2.188",
      clipRule: "evenodd"
    })
  }));
};

export { WarningIcon };
